const dialogueAudioMap: { [key: number]: string } = {
    0: require('../audio/dialogue/hi.wav'),
    1: require('../audio/dialogue/made.wav'),
    2: require('../audio/dialogue/answer.wav'),
    3: require('../audio/dialogue/flip.wav'),
    4: require('../audio/dialogue/muah.wav'),
    5: require('../audio/dialogue/instructions.wav')
}

export {dialogueAudioMap}